import { render, staticRenderFns } from "./CardPahoittelu.vue?vue&type=template&id=419c1efd&scoped=true&"
import script from "./CardPahoittelu.vue?vue&type=script&lang=js&"
export * from "./CardPahoittelu.vue?vue&type=script&lang=js&"
import style0 from "./CardPahoittelu.vue?vue&type=style&index=0&id=419c1efd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419c1efd",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('419c1efd')) {
      api.createRecord('419c1efd', component.options)
    } else {
      api.reload('419c1efd', component.options)
    }
    module.hot.accept("./CardPahoittelu.vue?vue&type=template&id=419c1efd&scoped=true&", function () {
      api.rerender('419c1efd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CardPahoittelu.vue"
export default component.exports